import { type Auth0ContextInterface } from '@equipmentshare/auth0-react'
import { useQuery } from 'react-query'
import { type Asset } from '~/../types'
import { fetchAsset } from '../calls/'

export const ASSET_QUERY_KEY = 'assetQueryKey'

type useAssetInput = {
	readonly assetId: string,
	readonly auth0: Auth0ContextInterface,
	readonly enabled: boolean,
}

export const useAsset = ( { assetId, auth0, enabled }: useAssetInput ) => useQuery<Asset, Error>(
	[ ASSET_QUERY_KEY, assetId ],
	async() => fetchAsset( auth0, assetId ),
	{ enabled },
)
